import { checkIsInternal, checkIsSimulationMode } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { NONPAYMENT_DETAILS_API_URL, NONPAYMENT_DETAILS_BENCH_MARK_AVG_API_URL, TOP_REASON_TOP_CAT_API_URL, TOP_REASON_SUB_CAT_API_URL, DOP_TOP_REASON_TOP_CAT_API_URL, DOP_TOP_REASON_SUB_CAT_API_URL, CLAIMS_TREND_GRAPH_API_URL, CLAIMS_TREND_LOB_API_URL, COMPLETE_AND_PARTIAL_TREND_URL, NONPAYMENT_DETAILS_BULK_API_URL, TOP_REASON_TOP_CAT_BULK_API_URL, TOP_REASON_SUB_CAT_BULK_API_URL, DOP_TOP_REASON_TOP_CAT_BULK_API_URL, DOP_TOP_REASON_SUB_CAT_BULK_API_URL, CLAIMS_TREND_GRAPH_BULK_API_URL, CLAIMS_TREND_LOB_BULK_API_URL, COMPLETE_AND_PARTIAL_TREND_BULK_URL } from './apiUrlConstants';
import { getJobId, queueJobPolling } from '@src/utility/CommonBulkPoll';

const _httpService = new HttpService();
const cache = new Map();

if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else{
 _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
 //_httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}

const tinGroupId = sessionStorage.getItem('tinGroupId')
  ? sessionStorage.getItem('tinGroupId')
  : '';

const addBulkPayloadContext = (payload: any, extraPayload: Record<string, unknown> = {}) => {
  const contractIdFlow = sessionStorage.getItem('contractIdNavigation') === 'true';
  return {
    ...(contractIdFlow ? {} : { TinGroupId: tinGroupId }),
    ...extraPayload,
    ...payload,
  };
};

// Helper function to get TimeFilterText based on TimeFilter value
const getTimeFilterText = (timeFilter: string, fallbackText?: string): string => {
  const timeFilterMap: { [key: string]: string } = {
    'Last30Days': 'Last 30 Days',
    'Last3Months': 'Last 3 Months',
    'Last6Months': 'Last 6 Months',
    'Last12Months': 'Last 12 Months',
    'YTD': 'Year to Date',
    'CalendarYear': fallbackText || 'Calendar Year'
  };
  return timeFilterMap[timeFilter] || timeFilter;
};

// Helper for polling a bulk job (same as PriorAuth pattern)
type PollBulkJobOptions = { onStop?: (stopFn: () => void) => void };
async function pollBulkJob<T = unknown>(
  endpoint: string,
  payload: Record<string, unknown>,
  options?: PollBulkJobOptions
): Promise<T> {
  const jobIdResponse = await getJobId(endpoint, payload);
  const jobId = jobIdResponse.Data.JobId;
  return new Promise<T>((resolve, reject) => {
    queueJobPolling(
      jobId,
      {
        onInProgress: () => {
},
        onCompleted: (result) => {
resolve(result as T);
        },
        onFailed: (errorMessage) => {
          console.error('Bulk Polling - Job failed:', errorMessage);
          reject(new Error(errorMessage));
        },
        onStatusUpdate: (statusResponse) => {
},
      },
      '/job-status/result',
      1000,
      undefined,
      false
    ).then((cleanup) => {
      if (options && typeof options.onStop === 'function') {
        options.onStop(cleanup);
      }
    });
  });
}

export const getNonPaymentDetails= async (payload:any) =>{
    const url = NONPAYMENT_DETAILS_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getNonPaymentDetailsBulk = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = addBulkPayloadContext(payload);

  try {
    // Assuming bulk endpoint - adjust the URL as per your API
    const bulkEndpoint = NONPAYMENT_DETAILS_BULK_API_URL

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );

    // Transform to match standard response format
    return {
      Status: 'OK',
      StatusCode: 200,
      Data: pollingResult,
    };
  } catch (error) {
    console.error('Error fetching NonPayment Details in bulk:', error);
    throw error;
  }
};

export const getNonPaymentDetailsBenchMarkAvg= async (payload:any) =>{
    const url = NONPAYMENT_DETAILS_BENCH_MARK_AVG_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getTopReasonTopCategory= async (payload:any) =>{
    let url ="";
    if(payload?.ClaimsBy === 'DOP'){
         url = DOP_TOP_REASON_TOP_CAT_API_URL;
    } else {
         url = TOP_REASON_TOP_CAT_API_URL;
    }
    let finalUrl = url;
    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getTopReasonSubCategory= async (payload:any) =>{
    let url ="";
    if(payload?.ClaimsBy === 'DOP'){
        url = DOP_TOP_REASON_SUB_CAT_API_URL;
   } else {
        url = TOP_REASON_SUB_CAT_API_URL;
   }
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getTopReasonTopCategoryBulk = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = addBulkPayloadContext(payload, {
    TimeFilterText: payload.TimeFilterText || getTimeFilterText(payload.TimeFilter || 'Last12Months', payload.TimeFilterText),
  });

  try {
    let bulkEndpoint = "";
    if (payload?.ClaimsBy === 'DOP') {
      bulkEndpoint = DOP_TOP_REASON_TOP_CAT_BULK_API_URL;
    } else {
      bulkEndpoint = TOP_REASON_TOP_CAT_BULK_API_URL;
    }

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );

    // Transform to match standard response format
    return {
      Status: 'OK',
      StatusCode: 200,
      Data: pollingResult,
    };
  } catch (error) {
    console.error('Error fetching Top Reason Top Category in bulk:', error);
    throw error;
  }
};

export const getTopReasonSubCategoryBulk = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = addBulkPayloadContext(payload, {
    TimeFilterText: payload.TimeFilterText || getTimeFilterText(payload.TimeFilter || 'Last12Months', payload.TimeFilterText),
  });

  try {
    let bulkEndpoint = "";
    if (payload?.ClaimsBy === 'DOP') {
      bulkEndpoint = DOP_TOP_REASON_SUB_CAT_BULK_API_URL;
    } else {
      bulkEndpoint = TOP_REASON_SUB_CAT_BULK_API_URL;
    }

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );

    // Transform to match standard response format
    return {
      Status: 'OK',
      StatusCode: 200,
      Data: pollingResult,
    };
  } catch (error) {
    console.error('Error fetching Top Reason Sub Category in bulk:', error);
    throw error;
  }
};

export const getClaimsTrendGraph= async (payload:any) =>{
    const url = CLAIMS_TREND_GRAPH_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getClaimsTrendGraphBulk = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = addBulkPayloadContext(payload);

  try {
    const bulkEndpoint = CLAIMS_TREND_GRAPH_BULK_API_URL;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );

    // Transform to match standard response format
    return {
      Status: 'OK',
      StatusCode: 200,
      Data: pollingResult,
    };
  } catch (error) {
    console.error('Error fetching Claims Trend Graph in bulk:', error);
    throw error;
  }
};

export const getClaimsTrendLOB= async (payload:any) =>{
    const url = CLAIMS_TREND_LOB_API_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getClaimsTrendLOBBulk = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = addBulkPayloadContext(payload);

  try {
    const bulkEndpoint = CLAIMS_TREND_LOB_BULK_API_URL;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );

    // Transform to match standard response format
    return {
      Status: 'OK',
      StatusCode: 200,
      Data: pollingResult,
    };
  } catch (error) {
    console.error('Error fetching Claims Trend LOB in bulk:', error);
    throw error;
  }
};

export const getNonPaymentCompleteAndPartialTrend= async (payload:any) =>{
    const url = COMPLETE_AND_PARTIAL_TREND_URL;
    let finalUrl = url;

    try {
        const responseData: any = await _httpService.push(finalUrl, payload);
        return responseData;
    } catch {
        return null;
    }
}

export const getNonPaymentCompleteAndPartialTrendBulk = async (
  payload: any,
  options?: { onStop?: (stopFn: () => void) => void }
): Promise<any> => {
  const updatedPayload = addBulkPayloadContext(payload);

  try {
    const bulkEndpoint = COMPLETE_AND_PARTIAL_TREND_BULK_URL;

    const pollingResult = await pollBulkJob<any>(
      bulkEndpoint,
      updatedPayload,
      options
    );

    // Transform to match standard response format
    return {
      Status: 'OK',
      StatusCode: 200,
      Data: pollingResult,
    };
  } catch (error) {
    console.error('Error fetching NonPayment Complete And Partial Trend in bulk:', error);
    throw error;
  }
};